'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isNumber = require('is-number');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  return !!value || value === 0 || value === '0' ? ('' + value).replace(/[^0-9]/g, '') * 1 : '';
};

var validate = function validate(value) {
  return (0, _isNumber2.default)(value) && /^\d*$/.test(value) && value * 1 >= 500 && value * 1 <= 1500;
};

exports.default = (0, _type2.default)({
  type: 'number',
  format: format,
  validate: validate
});